export default __webpack_public_path__ + "e12ada39c1abe0888ee7af419036e4cb.png";